import styled from 'styled-components'
import _MaterialList from '../MaterialList'

const MaterialList = styled(_MaterialList)`
	margin: 0;
`

export default { MaterialList }
